// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
    max-width: 900px;
    margin: 0 auto;
    padding: 0 24px 24px;
}

.dashboard-container .pageTitle {
    font-size: 24px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0;
}

/* ── Section Title ── */
.section-title {
    color: var(--text-primary);
    margin-bottom: 16px;
    font-size: 20px;
    font-weight: 700;
}

/* ── User Profile Header ── */
.dash-profile {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 20px;
    margin-bottom: 8px;
}

.dash-avatar {
    font-size: 48px;
    line-height: 1;
}

.dash-profile-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.dash-sync-badge {
    font-size: 12px;
    color: var(--dash-success);
    font-weight: 600;
}

/* ═══════════════════════════════
   HERO: Progress Ring + IRIS
   ═══════════════════════════════ */
.dash-hero {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 0 16px;
    opacity: 0;
    transform: translateY(16px);
    transition: opacity 0.5s ease, transform 0.5s ease;
}

.dash-hero--visible {
    opacity: 1;
    transform: translateY(0);
}

.dash-hero__ring-wrap {
    position: relative;
    width: 160px;
    height: 160px;
}

.dash-hero__ring {
    width: 100%;
    height: 100%;
}

.dash-hero__ring-progress {
    transition: stroke-dashoffset 1.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.dash-hero__mascot {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.dash-hero__streak {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
}

.dash-hero__flame {
    font-size: 28px;
    animation: flame-pulse 1.5s ease-in-out infinite;
}

@keyframes flame-pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.15); }
}

.dash-hero__streak-num {
    font-size: 36px;
    font-weight: 800;
    color: var(--dash-streak);
}

.dash-hero__streak-label {
    font-size: 14px;
    color: var(--text-muted);
    font-weight: 600;
}

.dash-hero__message {
    font-size: 15px;
    color: var(--text-secondary);
    text-align: center;
    margin: 8px 0 0;
    max-width: 300px;
}

.dash-hero__done-badge {
    display: inline-block;
    margin-top: 10px;
    padding: 4px 14px;
    border-radius: 20px;
    background: var(--dash-success-glow);
    color: var(--dash-success);
    font-size: 13px;
    font-weight: 700;
}

/* ═══════════════════════════════
   STAT CARDS
   ═══════════════════════════════ */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 12px;
    margin: 24px 0;
}

.stat-card {
    background-color: var(--bg-card);
    border: 2px solid var(--border-secondary);
    border-radius: 20px;
    padding: 20px 16px;
    text-align: center;
    transition: transform 0.2s, border-color 0.2s, box-shadow 0.2s;
    position: relative;
    overflow: hidden;
    opacity: 0;
    transform: translateY(12px);
}

.stat-card--visible {
    animation: card-enter 0.5s ease forwards;
}

@keyframes card-enter {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Color accent left border per card */
.stat-card--streak { border-left: 4px solid var(--dash-streak); }
.stat-card--record { border-left: 4px solid var(--dash-record); }
.stat-card--sessions { border-left: 4px solid var(--dash-sessions); }
.stat-card--points { border-left: 4px solid var(--dash-points); }

.stat-card:hover {
    transform: translateY(-3px);
    border-color: var(--border-hover);
}

/* Keep accent border on hover */
.stat-card--streak:hover { border-left-color: var(--dash-streak); box-shadow: 0 4px 16px var(--dash-streak-glow); }
.stat-card--record:hover { border-left-color: var(--dash-record); box-shadow: 0 4px 16px var(--dash-record-glow); }
.stat-card--sessions:hover { border-left-color: var(--dash-sessions); box-shadow: 0 4px 16px var(--dash-sessions-glow); }
.stat-card--points:hover { border-left-color: var(--dash-points); box-shadow: 0 4px 16px var(--dash-points-glow); }

.stat-icon {
    font-size: 28px;
    margin-bottom: 4px;
}

.stat-value {
    font-size: 32px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 4px 0;
}

.stat-label {
    font-size: 13px;
    color: var(--text-muted);
    margin: 2px 0;
}

.stat-sublabel {
    font-size: 11px;
    color: var(--text-muted-dark);
    margin-top: 4px;
}

/* ═══════════════════════════════
   WEEKLY MINI CHART
   ═══════════════════════════════ */
.dash-week {
    margin: 24px 0;
    background-color: var(--bg-card);
    border: 2px solid var(--border-secondary);
    border-radius: 20px;
    padding: 20px;
    opacity: 0;
    transform: translateY(12px);
    transition: opacity 0.5s ease 0.3s, transform 0.5s ease 0.3s;
}

.dash-week--visible {
    opacity: 1;
    transform: translateY(0);
}

.dash-week__chart {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    height: 80px;
    margin-top: 12px;
}

.dash-week__col {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
}

.dash-week__bar-track {
    flex: 1;
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.dash-week__bar {
    width: 100%;
    max-width: 36px;
    border-radius: 6px 6px 2px 2px;
    transition: height 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: relative;
    min-height: 0;
    background: var(--dash-bar-fill);
}

.dash-week__bar--today {
    background: var(--dash-bar-today);
    box-shadow: 0 0 8px var(--dash-success-glow);
}

.dash-week__bar--empty {
    height: 4px !important;
    background: var(--dash-bar-ghost);
    border-radius: 2px;
    width: 60%;
    max-width: 24px;
}

.dash-week__bar--future {
    height: 4px !important;
    background: var(--dash-bar-ghost);
    opacity: 0.4;
    border-radius: 2px;
    width: 60%;
    max-width: 24px;
    border: 1px dashed var(--text-muted-dark);
}

.dash-week__bar-count {
    position: absolute;
    top: -18px;
    font-size: 11px;
    font-weight: 700;
    color: var(--text-secondary);
}

.dash-week__day-label {
    font-size: 11px;
    font-weight: 600;
    color: var(--text-muted);
    margin-top: 6px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.dash-week__day-label--today {
    color: var(--dash-bar-today);
    font-weight: 700;
}

/* ═══════════════════════════════
   NEXT GOAL
   ═══════════════════════════════ */
.dash-next-goal {
    margin: 24px 0;
    background: linear-gradient(135deg, var(--card-featured-start), var(--card-featured-end));
    border: 2px solid var(--border-secondary);
    border-radius: 20px;
    padding: 20px;
    opacity: 0;
    transform: translateY(12px);
    transition: opacity 0.5s ease 0.4s, transform 0.5s ease 0.4s;
}

.dash-next-goal--visible {
    opacity: 1;
    transform: translateY(0);
}

.dash-next-goal__header {
    display: flex;
    align-items: center;
    gap: 8px;
}

.dash-next-goal__header .section-title {
    margin-bottom: 0;
}

.dash-next-goal__icon {
    font-size: 24px;
}

.dash-next-goal__text {
    color: var(--text-secondary);
    font-size: 14px;
    margin: 10px 0 14px;
    line-height: 1.5;
}

.dash-next-goal__bar-track {
    height: 8px;
    background: var(--dash-ring-track);
    border-radius: 4px;
    overflow: hidden;
}

.dash-next-goal__bar-fill {
    height: 100%;
    background: linear-gradient(90deg, var(--accent-primary), var(--dash-record));
    border-radius: 4px;
    transition: width 1s cubic-bezier(0.4, 0, 0.2, 1) 0.6s;
    position: relative;
}

/* ═══════════════════════════════
   XP LEVEL INDICATOR
   ═══════════════════════════════ */
.dash-xp-level {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 16px 0;
    padding: 12px 16px;
    background-color: var(--bg-card);
    border: 2px solid var(--border-secondary);
    border-radius: 16px;
}

.dash-xp-level__badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--accent-gradient-start), var(--accent-gradient-end));
    color: #ffffff;
    font-size: 18px;
    font-weight: 800;
    flex-shrink: 0;
}

.dash-xp-level__info {
    flex: 1;
    min-width: 0;
}

.dash-xp-level__label {
    font-size: 12px;
    font-weight: 700;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.dash-xp-level__bar-track {
    height: 6px;
    background: var(--dash-ring-track);
    border-radius: 3px;
    overflow: hidden;
    margin-top: 6px;
}

.dash-xp-level__bar-fill {
    height: 100%;
    background: linear-gradient(90deg, var(--accent-gradient-start), var(--accent-gradient-end));
    border-radius: 3px;
    transition: width 1s cubic-bezier(0.4, 0, 0.2, 1) 0.3s;
}

.dash-xp-level__xp {
    font-size: 11px;
    color: var(--text-muted-dark);
    margin-top: 4px;
}

/* ═══════════════════════════════
   SECTION STYLING
   ═══════════════════════════════ */
.section {
    margin: 32px 0;
}

/* ═══════════════════════════════
   CALENDAR GRID
   ═══════════════════════════════ */
.calendar-grid {
    background-color: var(--bg-card);
    border: 2px solid var(--border-secondary);
    border-radius: 20px;
    padding: 20px;
}

.calendar-month-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    gap: 12px;
}

.calendar-month-title {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
    letter-spacing: 0.01em;
    text-transform: capitalize;
    min-width: 160px;
    text-align: center;
}

.calendar-nav-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 12px;
    border: 2px solid var(--border-secondary);
    background: var(--bg-secondary);
    color: var(--text-primary);
    cursor: pointer;
    font-size: 16px;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.calendar-nav-btn:hover:not(:disabled) {
    border-color: var(--accent-primary);
    color: var(--accent-primary);
    transform: scale(1.08);
}

.calendar-nav-btn:active:not(:disabled) {
    transform: scale(0.95);
}

.calendar-nav-btn:disabled {
    opacity: 0.3;
    cursor: default;
}

.calendar-day-labels {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
    margin-bottom: 6px;
}

.calendar-day-label {
    text-align: center;
    font-size: 11px;
    font-weight: 700;
    color: var(--text-muted);
    padding: 4px 0;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.calendar-weeks {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.calendar-week {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
}

.calendar-day {
    min-height: 52px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: default;
    transition: transform 0.15s;
}

.calendar-day-number {
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    color: var(--text-primary);
}

.calendar-day-star {
    font-size: 15px;
    line-height: 1;
    margin-top: 3px;
}

.calendar-day.empty {
    background-color: transparent;
}

.calendar-day.future {
    background-color: var(--bg-secondary);
    opacity: 0.35;
}

.calendar-day.future .calendar-day-number {
    color: var(--text-muted);
}

/* Theme-aware heatmap colors */
.calendar-day.level-0 { background-color: var(--cal-level-0-bg); }
.calendar-day.level-0 .calendar-day-number { color: var(--cal-level-0-text); }
.calendar-day.level-1 { background-color: var(--cal-level-1-bg); }
.calendar-day.level-1 .calendar-day-number { color: var(--cal-level-1-text); }
.calendar-day.level-2 { background-color: var(--cal-level-2-bg); }
.calendar-day.level-2 .calendar-day-number { color: var(--cal-level-2-text); }
.calendar-day.level-3 { background-color: var(--cal-level-3-bg); }
.calendar-day.level-3 .calendar-day-number { color: var(--cal-level-3-text); }
.calendar-day.level-4 { background-color: var(--cal-level-4-bg); }
.calendar-day.level-4 .calendar-day-number { color: var(--cal-level-4-text); }

/* Today ring with pulse */
.calendar-day.today {
    box-shadow: 0 0 0 3px var(--accent-primary);
    animation: today-pulse 2.5s ease-in-out infinite;
}

@keyframes today-pulse {
    0%, 100% { box-shadow: 0 0 0 3px var(--accent-primary); }
    50% { box-shadow: 0 0 0 3px var(--accent-primary), 0 0 12px 2px var(--accent-primary); }
}

.calendar-day:not(.empty):not(.future):hover {
    transform: scale(1.08);
}

.calendar-legend {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 14px;
}

.legend-item {
    width: 20px;
    height: 20px;
    border-radius: 6px;
    flex-shrink: 0;
}

.legend-item.level-0 { background-color: var(--cal-level-0-bg); }
.legend-item.level-2 { background-color: var(--cal-level-2-bg); }
.legend-item.level-3 { background-color: var(--cal-level-3-bg); }
.legend-item.level-4 { background-color: var(--cal-level-4-bg); }

.legend-item-text {
    font-size: 11px;
    color: var(--text-muted);
    margin-right: 6px;
}

/* ═══════════════════════════════════════
   BADGES — Game-style achievement grid
   ═══════════════════════════════════════ */
.dash-badges-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
}

.dash-badges-header .section-title {
    margin-bottom: 0;
}

.dash-badges-count {
    font-size: 13px;
    color: var(--text-muted);
    font-weight: 600;
}

.dash-badges-progress-track {
    height: 6px;
    background: var(--dash-ring-track);
    border-radius: 3px;
    overflow: hidden;
    margin-bottom: 16px;
}

.dash-badges-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, var(--dash-record), var(--dash-streak));
    border-radius: 3px;
    transition: width 1s cubic-bezier(0.4, 0, 0.2, 1) 0.5s;
}

/* Badge category labels */
.badge-category-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--text-muted);
    margin: 20px 0 10px;
    padding-bottom: 6px;
    border-bottom: 1px solid var(--border-secondary);
}

.badge-category-label:first-child {
    margin-top: 0;
}

.badges-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 12px;
}

.badge-item {
    background-color: var(--bg-card);
    border: 2px solid var(--border-secondary);
    border-radius: 16px;
    padding: 16px 12px;
    text-align: center;
    transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), border-color 0.2s, box-shadow 0.3s;
    position: relative;
    overflow: hidden;
}

/* ── Earned badge ── */
.badge-item--earned:hover {
    transform: scale(1.08);
    border-color: var(--border-hover);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

/* Shimmer sweep on earned badges */
.badge-item--earned::after {
    content: '';
    position: absolute;
    top: 0;
    left: -120%;
    width: 60%;
    height: 100%;
    background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(255, 255, 255, 0.08) 40%,
        rgba(255, 255, 255, 0.15) 50%,
        rgba(255, 255, 255, 0.08) 60%,
        transparent 100%
    );
    transform: skewX(-15deg);
    pointer-events: none;
    animation: badge-shimmer 4s ease-in-out infinite;
    animation-delay: var(--shimmer-delay, 0s);
}

@keyframes badge-shimmer {
    0%   { left: -120%; }
    40%  { left: -120%; }
    100% { left: 220%; }
}

/* ── Locked badge ── */
.badge-item--locked {
    background-color: var(--dash-badge-locked-bg);
    border-color: var(--dash-badge-locked-border);
    opacity: 0.5;
}

.badge-item--locked .badge-icon .badge-art {
    width: 42px;
    height: 42px;
}

.badge-item--locked .badge-icon .badge-art-fallback {
    font-size: 32px;
}

.badge-item--locked .badge-name {
    color: var(--text-muted-dark);
}

/* ── Newly earned badge — golden glow ── */
.badge-item--new {
    border-color: var(--dash-record);
    box-shadow: 0 0 12px var(--dash-badge-new-glow);
    animation: badge-glow 2s ease-in-out infinite;
}

.badge-item--new .badge-icon .badge-art--earned {
    animation: badge-bounce 0.6s ease-out;
}

@keyframes badge-glow {
    0%, 100% { box-shadow: 0 0 8px var(--dash-badge-new-glow); }
    50% { box-shadow: 0 0 22px var(--dash-badge-new-glow), 0 0 40px var(--dash-badge-new-glow-wide, rgba(255, 215, 0, 0.15)); }
}

@keyframes badge-bounce {
    0%   { transform: scale(0.6); opacity: 0.5; }
    50%  { transform: scale(1.15); }
    70%  { transform: scale(0.95); }
    100% { transform: scale(1); opacity: 1; }
}

.badge-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 6px;
    position: relative;
}

.badge-icon .badge-art {
    width: 52px;
    height: 52px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
    transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.badge-item--earned:hover .badge-icon .badge-art {
    transform: scale(1.1) rotate(3deg);
}

.badge-icon .badge-art-fallback {
    font-size: 40px;
    line-height: 1;
}

.badge-name {
    font-size: 11px;
    color: var(--text-muted);
    word-wrap: break-word;
    font-weight: 500;
}

.badge-new-tag {
    position: absolute;
    top: 6px;
    right: 6px;
    font-size: 8px;
    font-weight: 800;
    color: var(--dash-record);
    background: var(--dash-record-glow);
    padding: 2px 5px;
    border-radius: 4px;
    letter-spacing: 0.05em;
    animation: tag-pulse 2s ease-in-out infinite;
}

@keyframes tag-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.7; }
}

.no-badges {
    text-align: center;
    font-style: italic;
    padding: 24px;
    color: var(--text-muted);
}

/* ═══════════════════════════════
   CTA BUTTON
   ═══════════════════════════════ */
.cta-section {
    text-align: center;
    margin: 32px 0;
}

.cta-sub {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 10px;
}

.cta-button {
    display: inline-block;
    color: white;
    font-size: 16px;
    font-weight: 700;
    padding: 14px 36px;
    border-radius: 50px;
    text-decoration: none;
    transition: transform 0.2s, box-shadow 0.2s;
    border: none;
    cursor: pointer;
}

.cta-button--pulse {
    background: linear-gradient(135deg, var(--accent-primary), var(--accent-gradient-end));
    animation: cta-pulse 2s ease-in-out infinite;
}

@keyframes cta-pulse {
    0%, 100% { box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3); }
    50% { box-shadow: 0 6px 20px rgba(74, 144, 226, 0.5); }
}

.cta-button--done {
    background: var(--dash-success);
}

.cta-button--done .cta-check {
    font-weight: 800;
}

.cta-button--warning {
    background: var(--dash-warning-cta);
    animation: cta-pulse-warning 1.5s ease-in-out infinite;
}

.cta-button--warning + .cta-sub,
.cta-section .cta-sub {
    color: var(--text-muted);
}

@keyframes cta-pulse-warning {
    0%, 100% { box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3); }
    50% { box-shadow: 0 6px 20px rgba(255, 152, 0, 0.5); }
}

.cta-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(74, 144, 226, 0.4);
}

.quebec-badge {
    text-align: center;
    padding: 16px;
}

/* ═══════════════════════════════
   IRIS DASHBOARD (compatibility)
   ═══════════════════════════════ */
.iris-dashboard {
    text-align: center;
}

/* ═══════════════════════════════
   ACCESSIBILITY: Reduced motion
   ═══════════════════════════════ */
@media (prefers-reduced-motion: reduce) {
    .dash-hero__flame,
    .badge-item--new,
    .badge-item--earned::after,
    .badge-item--new .badge-icon .badge-art--earned,
    .badge-new-tag,
    .calendar-day.today,
    .cta-button--pulse,
    .cta-button--warning {
        animation: none;
    }

    .dash-hero__ring-progress,
    .dash-next-goal__bar-fill,
    .dash-xp-level__bar-fill,
    .dash-badges-progress-fill {
        transition: none;
    }
}

/* ═══════════════════════════════
   RESPONSIVE
   ═══════════════════════════════ */
@media (max-width: 768px) {
    .dashboard-container {
        padding: 0 16px 16px;
    }

    .stats-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
    }

    .stat-card {
        padding: 16px 12px;
    }

    .stat-value {
        font-size: 24px;
    }

    .badges-grid {
        grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
        gap: 10px;
    }

    .calendar-day {
        min-height: 44px;
        border-radius: 10px;
    }

    .calendar-day-number {
        font-size: 12px;
    }

    .calendar-day-star {
        font-size: 13px;
    }

    .calendar-month-title {
        font-size: 18px;
        min-width: 140px;
    }

    .calendar-nav-btn {
        width: 36px;
        height: 36px;
    }

    .dash-hero__ring-wrap {
        width: 140px;
        height: 140px;
    }

    .dash-hero__streak-num {
        font-size: 28px;
    }

    .dash-week__chart {
        height: 70px;
    }
}

@media (max-width: 480px) {
    .stats-grid {
        grid-template-columns: 1fr 1fr;
    }

    .calendar-day {
        min-height: 36px;
        border-radius: 8px;
    }

    .calendar-day-number {
        font-size: 11px;
    }

    .calendar-day-star {
        font-size: 11px;
        margin-top: 1px;
    }

    .calendar-day-label {
        font-size: 9px;
        padding: 2px 0;
    }

    .calendar-month-title {
        font-size: 16px;
        min-width: 120px;
    }

    .calendar-nav-btn {
        width: 34px;
        height: 34px;
        border-radius: 10px;
        font-size: 14px;
    }

    .dashboard-container {
        padding-top: 0;
    }

    .dash-hero__ring-wrap {
        width: 120px;
        height: 120px;
    }

    .dash-hero__streak-num {
        font-size: 24px;
    }

    .dash-hero__flame {
        font-size: 22px;
    }

    .dash-hero__message {
        font-size: 13px;
    }

    .dash-week__chart {
        height: 60px;
        gap: 4px;
    }

    .dash-week__bar {
        max-width: 28px;
    }

    .badge-item {
        padding: 12px 8px;
    }

    .badge-icon .badge-art {
        width: 40px;
        height: 40px;
    }

    .badge-icon .badge-art-fallback {
        font-size: 32px;
    }

    .badge-item--locked .badge-icon .badge-art {
        width: 34px;
        height: 34px;
    }

    .badge-item--locked .badge-icon .badge-art-fallback {
        font-size: 26px;
    }

    .dash-badges-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }

    .dash-xp-level {
        padding: 10px 12px;
    }

    .dash-xp-level__badge {
        width: 36px;
        height: 36px;
        font-size: 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;AACb;;AAEA,wBAAwB;AACxB;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;;oCAEoC;AACpC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;IACV,2BAA2B;IAC3B,kDAAkD;AACtD;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,+DAA+D;AACnE;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gDAAgD;AACpD;;AAEA;IACI,WAAW,mBAAmB,EAAE;IAChC,MAAM,sBAAsB,EAAE;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,oCAAoC;IACpC,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;;oCAEoC;AACpC;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,8DAA8D;IAC9D,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,sCAAsC;AACtC,qBAAqB,yCAAyC,EAAE;AAChE,qBAAqB,yCAAyC,EAAE;AAChE,uBAAuB,2CAA2C,EAAE;AACpE,qBAAqB,yCAAyC,EAAE;;AAEhE;IACI,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA,gCAAgC;AAChC,2BAA2B,qCAAqC,EAAE,8CAA8C,EAAE;AAClH,2BAA2B,qCAAqC,EAAE,8CAA8C,EAAE;AAClH,6BAA6B,uCAAuC,EAAE,gDAAgD,EAAE;AACxH,2BAA2B,qCAAqC,EAAE,8CAA8C,EAAE;;AAElH;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;;oCAEoC;AACpC;IACI,cAAc;IACd,gCAAgC;IAChC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,2BAA2B;IAC3B,4DAA4D;AAChE;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,oDAAoD;IACpD,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;IACjC,4CAA4C;AAChD;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;;oCAEoC;AACpC;IACI,cAAc;IACd,yFAAyF;IACzF,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,2BAA2B;IAC3B,4DAA4D;AAChE;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,6EAA6E;IAC7E,kBAAkB;IAClB,sDAAsD;IACtD,kBAAkB;AACtB;;AAEA;;oCAEoC;AACpC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6FAA6F;IAC7F,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,4FAA4F;IAC5F,kBAAkB;IAClB,sDAAsD;AAC1D;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;;oCAEoC;AACpC;IACI,cAAc;AAClB;;AAEA;;oCAEoC;AACpC;IACI,gCAAgC;IAChC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,+BAA+B;IAC/B,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,+BAA+B;AAC/B,wBAAwB,uCAAuC,EAAE;AACjE,6CAA6C,8BAA8B,EAAE;AAC7E,wBAAwB,uCAAuC,EAAE;AACjE,6CAA6C,8BAA8B,EAAE;AAC7E,wBAAwB,uCAAuC,EAAE;AACjE,6CAA6C,8BAA8B,EAAE;AAC7E,wBAAwB,uCAAuC,EAAE;AACjE,6CAA6C,8BAA8B,EAAE;AAC7E,wBAAwB,uCAAuC,EAAE;AACjE,6CAA6C,8BAA8B,EAAE;;AAE7E,0BAA0B;AAC1B;IACI,2CAA2C;IAC3C,gDAAgD;AACpD;;AAEA;IACI,WAAW,2CAA2C,EAAE;IACxD,MAAM,+EAA+E,EAAE;AAC3F;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA,uBAAuB,uCAAuC,EAAE;AAChE,uBAAuB,uCAAuC,EAAE;AAChE,uBAAuB,uCAAuC,EAAE;AAChE,uBAAuB,uCAAuC,EAAE;;AAEhE;IACI,eAAe;IACf,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;;4CAE4C;AAC5C;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,0EAA0E;IAC1E,kBAAkB;IAClB,sDAAsD;AAC1D;;AAEA,0BAA0B;AAC1B;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iGAAiG;IACjG,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,sBAAsB;IACtB,iCAAiC;IACjC,0CAA0C;AAC9C;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,YAAY;IACZ;;;;;;;KAOC;IACD,wBAAwB;IACxB,oBAAoB;IACpB,gDAAgD;IAChD,yCAAyC;AAC7C;;AAEA;IACI,OAAO,WAAW,EAAE;IACpB,OAAO,WAAW,EAAE;IACpB,OAAO,UAAU,EAAE;AACvB;;AAEA,uBAAuB;AACvB;IACI,6CAA6C;IAC7C,6CAA6C;IAC7C,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA,2CAA2C;AAC3C;IACI,gCAAgC;IAChC,+CAA+C;IAC/C,6CAA6C;AACjD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,WAAW,8CAA8C,EAAE;IAC3D,MAAM,kHAAkH,EAAE;AAC9H;;AAEA;IACI,OAAO,qBAAqB,EAAE,YAAY,EAAE;IAC5C,OAAO,sBAAsB,EAAE;IAC/B,OAAO,sBAAsB,EAAE;IAC/B,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC5C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kDAAkD;IAClD,6DAA6D;AACjE;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,4CAA4C;AAChD;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,MAAM,YAAY,EAAE;AACxB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;;oCAEoC;AACpC;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,2CAA2C;IAC3C,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,sFAAsF;IACtF,4CAA4C;AAChD;;AAEA;IACI,WAAW,8CAA8C,EAAE;IAC3D,MAAM,8CAA8C,EAAE;AAC1D;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,sDAAsD;AAC1D;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,WAAW,6CAA6C,EAAE;IAC1D,MAAM,6CAA6C,EAAE;AACzD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;oCAEoC;AACpC;IACI,kBAAkB;AACtB;;AAEA;;oCAEoC;AACpC;IACI;;;;;;;;QAQI,eAAe;IACnB;;IAEA;;;;QAII,gBAAgB;IACpB;AACJ;;AAEA;;oCAEoC;AACpC;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,2DAA2D;QAC3D,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":[".dashboard-container {\n    max-width: 900px;\n    margin: 0 auto;\n    padding: 0 24px 24px;\n}\n\n.dashboard-container .pageTitle {\n    font-size: 24px;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin: 0;\n}\n\n/* ── Section Title ── */\n.section-title {\n    color: var(--text-primary);\n    margin-bottom: 16px;\n    font-size: 20px;\n    font-weight: 700;\n}\n\n/* ── User Profile Header ── */\n.dash-profile {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-top: 20px;\n    margin-bottom: 8px;\n}\n\n.dash-avatar {\n    font-size: 48px;\n    line-height: 1;\n}\n\n.dash-profile-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.dash-sync-badge {\n    font-size: 12px;\n    color: var(--dash-success);\n    font-weight: 600;\n}\n\n/* ═══════════════════════════════\n   HERO: Progress Ring + IRIS\n   ═══════════════════════════════ */\n.dash-hero {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 24px 0 16px;\n    opacity: 0;\n    transform: translateY(16px);\n    transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n.dash-hero--visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.dash-hero__ring-wrap {\n    position: relative;\n    width: 160px;\n    height: 160px;\n}\n\n.dash-hero__ring {\n    width: 100%;\n    height: 100%;\n}\n\n.dash-hero__ring-progress {\n    transition: stroke-dashoffset 1.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.dash-hero__mascot {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.dash-hero__streak {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 16px;\n}\n\n.dash-hero__flame {\n    font-size: 28px;\n    animation: flame-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes flame-pulse {\n    0%, 100% { transform: scale(1); }\n    50% { transform: scale(1.15); }\n}\n\n.dash-hero__streak-num {\n    font-size: 36px;\n    font-weight: 800;\n    color: var(--dash-streak);\n}\n\n.dash-hero__streak-label {\n    font-size: 14px;\n    color: var(--text-muted);\n    font-weight: 600;\n}\n\n.dash-hero__message {\n    font-size: 15px;\n    color: var(--text-secondary);\n    text-align: center;\n    margin: 8px 0 0;\n    max-width: 300px;\n}\n\n.dash-hero__done-badge {\n    display: inline-block;\n    margin-top: 10px;\n    padding: 4px 14px;\n    border-radius: 20px;\n    background: var(--dash-success-glow);\n    color: var(--dash-success);\n    font-size: 13px;\n    font-weight: 700;\n}\n\n/* ═══════════════════════════════\n   STAT CARDS\n   ═══════════════════════════════ */\n.stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n    gap: 12px;\n    margin: 24px 0;\n}\n\n.stat-card {\n    background-color: var(--bg-card);\n    border: 2px solid var(--border-secondary);\n    border-radius: 20px;\n    padding: 20px 16px;\n    text-align: center;\n    transition: transform 0.2s, border-color 0.2s, box-shadow 0.2s;\n    position: relative;\n    overflow: hidden;\n    opacity: 0;\n    transform: translateY(12px);\n}\n\n.stat-card--visible {\n    animation: card-enter 0.5s ease forwards;\n}\n\n@keyframes card-enter {\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Color accent left border per card */\n.stat-card--streak { border-left: 4px solid var(--dash-streak); }\n.stat-card--record { border-left: 4px solid var(--dash-record); }\n.stat-card--sessions { border-left: 4px solid var(--dash-sessions); }\n.stat-card--points { border-left: 4px solid var(--dash-points); }\n\n.stat-card:hover {\n    transform: translateY(-3px);\n    border-color: var(--border-hover);\n}\n\n/* Keep accent border on hover */\n.stat-card--streak:hover { border-left-color: var(--dash-streak); box-shadow: 0 4px 16px var(--dash-streak-glow); }\n.stat-card--record:hover { border-left-color: var(--dash-record); box-shadow: 0 4px 16px var(--dash-record-glow); }\n.stat-card--sessions:hover { border-left-color: var(--dash-sessions); box-shadow: 0 4px 16px var(--dash-sessions-glow); }\n.stat-card--points:hover { border-left-color: var(--dash-points); box-shadow: 0 4px 16px var(--dash-points-glow); }\n\n.stat-icon {\n    font-size: 28px;\n    margin-bottom: 4px;\n}\n\n.stat-value {\n    font-size: 32px;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin: 4px 0;\n}\n\n.stat-label {\n    font-size: 13px;\n    color: var(--text-muted);\n    margin: 2px 0;\n}\n\n.stat-sublabel {\n    font-size: 11px;\n    color: var(--text-muted-dark);\n    margin-top: 4px;\n}\n\n/* ═══════════════════════════════\n   WEEKLY MINI CHART\n   ═══════════════════════════════ */\n.dash-week {\n    margin: 24px 0;\n    background-color: var(--bg-card);\n    border: 2px solid var(--border-secondary);\n    border-radius: 20px;\n    padding: 20px;\n    opacity: 0;\n    transform: translateY(12px);\n    transition: opacity 0.5s ease 0.3s, transform 0.5s ease 0.3s;\n}\n\n.dash-week--visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.dash-week__chart {\n    display: flex;\n    align-items: flex-end;\n    gap: 8px;\n    height: 80px;\n    margin-top: 12px;\n}\n\n.dash-week__col {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100%;\n}\n\n.dash-week__bar-track {\n    flex: 1;\n    width: 100%;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n}\n\n.dash-week__bar {\n    width: 100%;\n    max-width: 36px;\n    border-radius: 6px 6px 2px 2px;\n    transition: height 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    position: relative;\n    min-height: 0;\n    background: var(--dash-bar-fill);\n}\n\n.dash-week__bar--today {\n    background: var(--dash-bar-today);\n    box-shadow: 0 0 8px var(--dash-success-glow);\n}\n\n.dash-week__bar--empty {\n    height: 4px !important;\n    background: var(--dash-bar-ghost);\n    border-radius: 2px;\n    width: 60%;\n    max-width: 24px;\n}\n\n.dash-week__bar--future {\n    height: 4px !important;\n    background: var(--dash-bar-ghost);\n    opacity: 0.4;\n    border-radius: 2px;\n    width: 60%;\n    max-width: 24px;\n    border: 1px dashed var(--text-muted-dark);\n}\n\n.dash-week__bar-count {\n    position: absolute;\n    top: -18px;\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--text-secondary);\n}\n\n.dash-week__day-label {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-muted);\n    margin-top: 6px;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.dash-week__day-label--today {\n    color: var(--dash-bar-today);\n    font-weight: 700;\n}\n\n/* ═══════════════════════════════\n   NEXT GOAL\n   ═══════════════════════════════ */\n.dash-next-goal {\n    margin: 24px 0;\n    background: linear-gradient(135deg, var(--card-featured-start), var(--card-featured-end));\n    border: 2px solid var(--border-secondary);\n    border-radius: 20px;\n    padding: 20px;\n    opacity: 0;\n    transform: translateY(12px);\n    transition: opacity 0.5s ease 0.4s, transform 0.5s ease 0.4s;\n}\n\n.dash-next-goal--visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.dash-next-goal__header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.dash-next-goal__header .section-title {\n    margin-bottom: 0;\n}\n\n.dash-next-goal__icon {\n    font-size: 24px;\n}\n\n.dash-next-goal__text {\n    color: var(--text-secondary);\n    font-size: 14px;\n    margin: 10px 0 14px;\n    line-height: 1.5;\n}\n\n.dash-next-goal__bar-track {\n    height: 8px;\n    background: var(--dash-ring-track);\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.dash-next-goal__bar-fill {\n    height: 100%;\n    background: linear-gradient(90deg, var(--accent-primary), var(--dash-record));\n    border-radius: 4px;\n    transition: width 1s cubic-bezier(0.4, 0, 0.2, 1) 0.6s;\n    position: relative;\n}\n\n/* ═══════════════════════════════\n   XP LEVEL INDICATOR\n   ═══════════════════════════════ */\n.dash-xp-level {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin: 16px 0;\n    padding: 12px 16px;\n    background-color: var(--bg-card);\n    border: 2px solid var(--border-secondary);\n    border-radius: 16px;\n}\n\n.dash-xp-level__badge {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, var(--accent-gradient-start), var(--accent-gradient-end));\n    color: #ffffff;\n    font-size: 18px;\n    font-weight: 800;\n    flex-shrink: 0;\n}\n\n.dash-xp-level__info {\n    flex: 1;\n    min-width: 0;\n}\n\n.dash-xp-level__label {\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.dash-xp-level__bar-track {\n    height: 6px;\n    background: var(--dash-ring-track);\n    border-radius: 3px;\n    overflow: hidden;\n    margin-top: 6px;\n}\n\n.dash-xp-level__bar-fill {\n    height: 100%;\n    background: linear-gradient(90deg, var(--accent-gradient-start), var(--accent-gradient-end));\n    border-radius: 3px;\n    transition: width 1s cubic-bezier(0.4, 0, 0.2, 1) 0.3s;\n}\n\n.dash-xp-level__xp {\n    font-size: 11px;\n    color: var(--text-muted-dark);\n    margin-top: 4px;\n}\n\n/* ═══════════════════════════════\n   SECTION STYLING\n   ═══════════════════════════════ */\n.section {\n    margin: 32px 0;\n}\n\n/* ═══════════════════════════════\n   CALENDAR GRID\n   ═══════════════════════════════ */\n.calendar-grid {\n    background-color: var(--bg-card);\n    border: 2px solid var(--border-secondary);\n    border-radius: 20px;\n    padding: 20px;\n}\n\n.calendar-month-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 16px;\n    gap: 12px;\n}\n\n.calendar-month-title {\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n    letter-spacing: 0.01em;\n    text-transform: capitalize;\n    min-width: 160px;\n    text-align: center;\n}\n\n.calendar-nav-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 12px;\n    border: 2px solid var(--border-secondary);\n    background: var(--bg-secondary);\n    color: var(--text-primary);\n    cursor: pointer;\n    font-size: 16px;\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n}\n\n.calendar-nav-btn:hover:not(:disabled) {\n    border-color: var(--accent-primary);\n    color: var(--accent-primary);\n    transform: scale(1.08);\n}\n\n.calendar-nav-btn:active:not(:disabled) {\n    transform: scale(0.95);\n}\n\n.calendar-nav-btn:disabled {\n    opacity: 0.3;\n    cursor: default;\n}\n\n.calendar-day-labels {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 4px;\n    margin-bottom: 6px;\n}\n\n.calendar-day-label {\n    text-align: center;\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--text-muted);\n    padding: 4px 0;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n}\n\n.calendar-weeks {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.calendar-week {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 4px;\n}\n\n.calendar-day {\n    min-height: 52px;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    cursor: default;\n    transition: transform 0.15s;\n}\n\n.calendar-day-number {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1;\n    color: var(--text-primary);\n}\n\n.calendar-day-star {\n    font-size: 15px;\n    line-height: 1;\n    margin-top: 3px;\n}\n\n.calendar-day.empty {\n    background-color: transparent;\n}\n\n.calendar-day.future {\n    background-color: var(--bg-secondary);\n    opacity: 0.35;\n}\n\n.calendar-day.future .calendar-day-number {\n    color: var(--text-muted);\n}\n\n/* Theme-aware heatmap colors */\n.calendar-day.level-0 { background-color: var(--cal-level-0-bg); }\n.calendar-day.level-0 .calendar-day-number { color: var(--cal-level-0-text); }\n.calendar-day.level-1 { background-color: var(--cal-level-1-bg); }\n.calendar-day.level-1 .calendar-day-number { color: var(--cal-level-1-text); }\n.calendar-day.level-2 { background-color: var(--cal-level-2-bg); }\n.calendar-day.level-2 .calendar-day-number { color: var(--cal-level-2-text); }\n.calendar-day.level-3 { background-color: var(--cal-level-3-bg); }\n.calendar-day.level-3 .calendar-day-number { color: var(--cal-level-3-text); }\n.calendar-day.level-4 { background-color: var(--cal-level-4-bg); }\n.calendar-day.level-4 .calendar-day-number { color: var(--cal-level-4-text); }\n\n/* Today ring with pulse */\n.calendar-day.today {\n    box-shadow: 0 0 0 3px var(--accent-primary);\n    animation: today-pulse 2.5s ease-in-out infinite;\n}\n\n@keyframes today-pulse {\n    0%, 100% { box-shadow: 0 0 0 3px var(--accent-primary); }\n    50% { box-shadow: 0 0 0 3px var(--accent-primary), 0 0 12px 2px var(--accent-primary); }\n}\n\n.calendar-day:not(.empty):not(.future):hover {\n    transform: scale(1.08);\n}\n\n.calendar-legend {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 14px;\n}\n\n.legend-item {\n    width: 20px;\n    height: 20px;\n    border-radius: 6px;\n    flex-shrink: 0;\n}\n\n.legend-item.level-0 { background-color: var(--cal-level-0-bg); }\n.legend-item.level-2 { background-color: var(--cal-level-2-bg); }\n.legend-item.level-3 { background-color: var(--cal-level-3-bg); }\n.legend-item.level-4 { background-color: var(--cal-level-4-bg); }\n\n.legend-item-text {\n    font-size: 11px;\n    color: var(--text-muted);\n    margin-right: 6px;\n}\n\n/* ═══════════════════════════════════════\n   BADGES — Game-style achievement grid\n   ═══════════════════════════════════════ */\n.dash-badges-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 4px;\n}\n\n.dash-badges-header .section-title {\n    margin-bottom: 0;\n}\n\n.dash-badges-count {\n    font-size: 13px;\n    color: var(--text-muted);\n    font-weight: 600;\n}\n\n.dash-badges-progress-track {\n    height: 6px;\n    background: var(--dash-ring-track);\n    border-radius: 3px;\n    overflow: hidden;\n    margin-bottom: 16px;\n}\n\n.dash-badges-progress-fill {\n    height: 100%;\n    background: linear-gradient(90deg, var(--dash-record), var(--dash-streak));\n    border-radius: 3px;\n    transition: width 1s cubic-bezier(0.4, 0, 0.2, 1) 0.5s;\n}\n\n/* Badge category labels */\n.badge-category-label {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: var(--text-muted);\n    margin: 20px 0 10px;\n    padding-bottom: 6px;\n    border-bottom: 1px solid var(--border-secondary);\n}\n\n.badge-category-label:first-child {\n    margin-top: 0;\n}\n\n.badges-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n    gap: 12px;\n}\n\n.badge-item {\n    background-color: var(--bg-card);\n    border: 2px solid var(--border-secondary);\n    border-radius: 16px;\n    padding: 16px 12px;\n    text-align: center;\n    transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), border-color 0.2s, box-shadow 0.3s;\n    position: relative;\n    overflow: hidden;\n}\n\n/* ── Earned badge ── */\n.badge-item--earned:hover {\n    transform: scale(1.08);\n    border-color: var(--border-hover);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n/* Shimmer sweep on earned badges */\n.badge-item--earned::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -120%;\n    width: 60%;\n    height: 100%;\n    background: linear-gradient(\n        90deg,\n        transparent 0%,\n        rgba(255, 255, 255, 0.08) 40%,\n        rgba(255, 255, 255, 0.15) 50%,\n        rgba(255, 255, 255, 0.08) 60%,\n        transparent 100%\n    );\n    transform: skewX(-15deg);\n    pointer-events: none;\n    animation: badge-shimmer 4s ease-in-out infinite;\n    animation-delay: var(--shimmer-delay, 0s);\n}\n\n@keyframes badge-shimmer {\n    0%   { left: -120%; }\n    40%  { left: -120%; }\n    100% { left: 220%; }\n}\n\n/* ── Locked badge ── */\n.badge-item--locked {\n    background-color: var(--dash-badge-locked-bg);\n    border-color: var(--dash-badge-locked-border);\n    opacity: 0.5;\n}\n\n.badge-item--locked .badge-icon .badge-art {\n    width: 42px;\n    height: 42px;\n}\n\n.badge-item--locked .badge-icon .badge-art-fallback {\n    font-size: 32px;\n}\n\n.badge-item--locked .badge-name {\n    color: var(--text-muted-dark);\n}\n\n/* ── Newly earned badge — golden glow ── */\n.badge-item--new {\n    border-color: var(--dash-record);\n    box-shadow: 0 0 12px var(--dash-badge-new-glow);\n    animation: badge-glow 2s ease-in-out infinite;\n}\n\n.badge-item--new .badge-icon .badge-art--earned {\n    animation: badge-bounce 0.6s ease-out;\n}\n\n@keyframes badge-glow {\n    0%, 100% { box-shadow: 0 0 8px var(--dash-badge-new-glow); }\n    50% { box-shadow: 0 0 22px var(--dash-badge-new-glow), 0 0 40px var(--dash-badge-new-glow-wide, rgba(255, 215, 0, 0.15)); }\n}\n\n@keyframes badge-bounce {\n    0%   { transform: scale(0.6); opacity: 0.5; }\n    50%  { transform: scale(1.15); }\n    70%  { transform: scale(0.95); }\n    100% { transform: scale(1); opacity: 1; }\n}\n\n.badge-icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 6px;\n    position: relative;\n}\n\n.badge-icon .badge-art {\n    width: 52px;\n    height: 52px;\n    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));\n    transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.badge-item--earned:hover .badge-icon .badge-art {\n    transform: scale(1.1) rotate(3deg);\n}\n\n.badge-icon .badge-art-fallback {\n    font-size: 40px;\n    line-height: 1;\n}\n\n.badge-name {\n    font-size: 11px;\n    color: var(--text-muted);\n    word-wrap: break-word;\n    font-weight: 500;\n}\n\n.badge-new-tag {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    font-size: 8px;\n    font-weight: 800;\n    color: var(--dash-record);\n    background: var(--dash-record-glow);\n    padding: 2px 5px;\n    border-radius: 4px;\n    letter-spacing: 0.05em;\n    animation: tag-pulse 2s ease-in-out infinite;\n}\n\n@keyframes tag-pulse {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.7; }\n}\n\n.no-badges {\n    text-align: center;\n    font-style: italic;\n    padding: 24px;\n    color: var(--text-muted);\n}\n\n/* ═══════════════════════════════\n   CTA BUTTON\n   ═══════════════════════════════ */\n.cta-section {\n    text-align: center;\n    margin: 32px 0;\n}\n\n.cta-sub {\n    font-size: 13px;\n    font-weight: 600;\n    margin-bottom: 10px;\n}\n\n.cta-button {\n    display: inline-block;\n    color: white;\n    font-size: 16px;\n    font-weight: 700;\n    padding: 14px 36px;\n    border-radius: 50px;\n    text-decoration: none;\n    transition: transform 0.2s, box-shadow 0.2s;\n    border: none;\n    cursor: pointer;\n}\n\n.cta-button--pulse {\n    background: linear-gradient(135deg, var(--accent-primary), var(--accent-gradient-end));\n    animation: cta-pulse 2s ease-in-out infinite;\n}\n\n@keyframes cta-pulse {\n    0%, 100% { box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3); }\n    50% { box-shadow: 0 6px 20px rgba(74, 144, 226, 0.5); }\n}\n\n.cta-button--done {\n    background: var(--dash-success);\n}\n\n.cta-button--done .cta-check {\n    font-weight: 800;\n}\n\n.cta-button--warning {\n    background: var(--dash-warning-cta);\n    animation: cta-pulse-warning 1.5s ease-in-out infinite;\n}\n\n.cta-button--warning + .cta-sub,\n.cta-section .cta-sub {\n    color: var(--text-muted);\n}\n\n@keyframes cta-pulse-warning {\n    0%, 100% { box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3); }\n    50% { box-shadow: 0 6px 20px rgba(255, 152, 0, 0.5); }\n}\n\n.cta-button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(74, 144, 226, 0.4);\n}\n\n.quebec-badge {\n    text-align: center;\n    padding: 16px;\n}\n\n/* ═══════════════════════════════\n   IRIS DASHBOARD (compatibility)\n   ═══════════════════════════════ */\n.iris-dashboard {\n    text-align: center;\n}\n\n/* ═══════════════════════════════\n   ACCESSIBILITY: Reduced motion\n   ═══════════════════════════════ */\n@media (prefers-reduced-motion: reduce) {\n    .dash-hero__flame,\n    .badge-item--new,\n    .badge-item--earned::after,\n    .badge-item--new .badge-icon .badge-art--earned,\n    .badge-new-tag,\n    .calendar-day.today,\n    .cta-button--pulse,\n    .cta-button--warning {\n        animation: none;\n    }\n\n    .dash-hero__ring-progress,\n    .dash-next-goal__bar-fill,\n    .dash-xp-level__bar-fill,\n    .dash-badges-progress-fill {\n        transition: none;\n    }\n}\n\n/* ═══════════════════════════════\n   RESPONSIVE\n   ═══════════════════════════════ */\n@media (max-width: 768px) {\n    .dashboard-container {\n        padding: 0 16px 16px;\n    }\n\n    .stats-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 10px;\n    }\n\n    .stat-card {\n        padding: 16px 12px;\n    }\n\n    .stat-value {\n        font-size: 24px;\n    }\n\n    .badges-grid {\n        grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n        gap: 10px;\n    }\n\n    .calendar-day {\n        min-height: 44px;\n        border-radius: 10px;\n    }\n\n    .calendar-day-number {\n        font-size: 12px;\n    }\n\n    .calendar-day-star {\n        font-size: 13px;\n    }\n\n    .calendar-month-title {\n        font-size: 18px;\n        min-width: 140px;\n    }\n\n    .calendar-nav-btn {\n        width: 36px;\n        height: 36px;\n    }\n\n    .dash-hero__ring-wrap {\n        width: 140px;\n        height: 140px;\n    }\n\n    .dash-hero__streak-num {\n        font-size: 28px;\n    }\n\n    .dash-week__chart {\n        height: 70px;\n    }\n}\n\n@media (max-width: 480px) {\n    .stats-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .calendar-day {\n        min-height: 36px;\n        border-radius: 8px;\n    }\n\n    .calendar-day-number {\n        font-size: 11px;\n    }\n\n    .calendar-day-star {\n        font-size: 11px;\n        margin-top: 1px;\n    }\n\n    .calendar-day-label {\n        font-size: 9px;\n        padding: 2px 0;\n    }\n\n    .calendar-month-title {\n        font-size: 16px;\n        min-width: 120px;\n    }\n\n    .calendar-nav-btn {\n        width: 34px;\n        height: 34px;\n        border-radius: 10px;\n        font-size: 14px;\n    }\n\n    .dashboard-container {\n        padding-top: 0;\n    }\n\n    .dash-hero__ring-wrap {\n        width: 120px;\n        height: 120px;\n    }\n\n    .dash-hero__streak-num {\n        font-size: 24px;\n    }\n\n    .dash-hero__flame {\n        font-size: 22px;\n    }\n\n    .dash-hero__message {\n        font-size: 13px;\n    }\n\n    .dash-week__chart {\n        height: 60px;\n        gap: 4px;\n    }\n\n    .dash-week__bar {\n        max-width: 28px;\n    }\n\n    .badge-item {\n        padding: 12px 8px;\n    }\n\n    .badge-icon .badge-art {\n        width: 40px;\n        height: 40px;\n    }\n\n    .badge-icon .badge-art-fallback {\n        font-size: 32px;\n    }\n\n    .badge-item--locked .badge-icon .badge-art {\n        width: 34px;\n        height: 34px;\n    }\n\n    .badge-item--locked .badge-icon .badge-art-fallback {\n        font-size: 26px;\n    }\n\n    .dash-badges-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 4px;\n    }\n\n    .dash-xp-level {\n        padding: 10px 12px;\n    }\n\n    .dash-xp-level__badge {\n        width: 36px;\n        height: 36px;\n        font-size: 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
